import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

export interface PantheonDto {
	id: string;
	worldId: string;
	name: string;
	currentState?: string | null;
	historicalState?: string | null;
	description?: string | null;
	gmNotes?: string | null;
	iconographyAssetId?: string | null;
	foundryId?: string | null;
	createdAt: string;
	updatedAt: string;
}

export interface PantheonsListResponse {
	pantheons: PantheonDto[];
	total: number;
}

export interface PantheonGetResponse {
	pantheon: PantheonDto;
}

export interface UpsertPantheonRequest {
	name: string;
	currentState?: string | null;
	historicalState?: string | null;
	description?: string | null;
	gmNotes?: string | null;
	iconographyAssetId?: string | null;
	foundryId?: string | null;
}

@Injectable({ providedIn: 'root' })
export class PantheonsService {
	constructor(private readonly http: HttpClient) {}

	list(worldId: string, q?: string): Observable<PantheonsListResponse> {
		let params = new HttpParams().set('format', 'list');
		if (q) params = params.set('q', q);
		return this.http.get<PantheonsListResponse>(`${environment.api.baseUrl}/v1/worlds/${worldId}/pantheons`, { params });
	}

	get(worldId: string, pantheonId: string): Observable<PantheonGetResponse> {
		return this.http.get<PantheonGetResponse>(`${environment.api.baseUrl}/v1/worlds/${worldId}/pantheons/${pantheonId}`);
	}

	create(worldId: string, request: UpsertPantheonRequest): Observable<PantheonGetResponse> {
		return this.http.post<PantheonGetResponse>(`${environment.api.baseUrl}/v1/worlds/${worldId}/pantheons`, {
			Name: request.name,
			CurrentState: request.currentState ?? null,
			HistoricalState: request.historicalState ?? null,
			Description: request.description ?? null,
			GmNotes: request.gmNotes ?? null,
			IconographyAssetId: request.iconographyAssetId ?? null,
			FoundryId: request.foundryId ?? null,
		});
	}

	update(worldId: string, pantheonId: string, request: UpsertPantheonRequest): Observable<PantheonGetResponse> {
		return this.http.put<PantheonGetResponse>(`${environment.api.baseUrl}/v1/worlds/${worldId}/pantheons/${pantheonId}`, {
			Name: request.name,
			CurrentState: request.currentState ?? null,
			HistoricalState: request.historicalState ?? null,
			Description: request.description ?? null,
			GmNotes: request.gmNotes ?? null,
			IconographyAssetId: request.iconographyAssetId ?? null,
			FoundryId: request.foundryId ?? null,
		});
	}

	delete(worldId: string, pantheonId: string): Observable<void> {
		return this.http.delete<void>(`${environment.api.baseUrl}/v1/worlds/${worldId}/pantheons/${pantheonId}`);
	}
}
